import { useState, useEffect, useCallback } from 'react';
import { Select, Checkbox, notification, Spin } from "antd";
import "./PrivilegesTable.scss";
import service from "../../services/Service"
import { useGetRolesLookupQuery } from '../../services/lookupApi.js';
import { USER_PRIVILEGES } from "../../utils/user-privileges";
import { withLocale } from '../../l10n';
const { Option } = Select;


function PrivilegesTable({ lang }) {

  // ===== 1. ESTADOS =====
  const [ui, setUI] = useState({
    loading: false,
    isSubmitting: false,
  });

  const [data, setData] = useState({
    privileges: structuredClone(USER_PRIVILEGES),
    role: null,
  });

  const { data: roles = [] } = useGetRolesLookupQuery();

  // ===== 2. HELPERS (Para actualizar estado) =====
  const updateUI = (field, value) => setUI(prev => ({ ...prev, [field]: value }));
  const updateData = (field, value) => setData(prev => ({ ...prev, [field]: value }));

  // ===== 3. FUNCIONES PRINCIPALES =====
  const fetchPrivileges = useCallback(async (roleId) => {
    if (!roleId) return;

    updateUI('loading', true);

    try {
      const fetchedPrivileges = {};
      const res = await service.get("privileges/role/" + roleId);
      const resp = res.data;
      for (let i = 0; i < resp.length; i++) {
        fetchedPrivileges[resp[i].name] = {
          name: resp[i].name,
          uuid: resp[i].uuid,
          active: resp[i].value,
          permission: resp[i].permission
        };
      }

      setData(prev => {
        const newPrivileges = structuredClone(prev.privileges);
        Object.keys(newPrivileges).forEach(groupKey => {
          Object.keys(newPrivileges[groupKey].privileges).forEach(privKey => {
            if (fetchedPrivileges[privKey]) {
              newPrivileges[groupKey].privileges[privKey].uuid =
                fetchedPrivileges[privKey].uuid;
              newPrivileges[groupKey].privileges[privKey].active =
                fetchedPrivileges[privKey].active;
              newPrivileges[groupKey].privileges[privKey].permission =
                fetchedPrivileges[privKey].permission;
            }
          });
        });

        return {
          ...prev,
          privileges: newPrivileges
        };
      });

    } catch (err) {
      console.log("Error devuelto:", err);
      notification["error"]({
        message: lang.handle('Error al obtener datos'),
      });

    } finally {
      updateUI('loading', false);
    }
  }, [lang]);

  // ===== 4. HANDLERS =====
  const handlePrivilegeToggle = (groupKey, privKey) => () => {
    setData(prev => {
      const newPrivileges = structuredClone(prev.privileges);
      const currentActive = newPrivileges[groupKey].privileges[privKey].active;
      newPrivileges[groupKey].privileges[privKey].active = !currentActive;
      return { ...prev, privileges: newPrivileges };
    });
  };

  const handleRoleChange = (value) => {
    updateData('role', value);
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (ui.isSubmitting || !data.role) return;
    updateUI('isSubmitting', true);

    try {
      const res = await service.post(
        `privileges/role/${data.role}`,
        data.privileges
      );
      if (res.data.ok === false) {
        notification["error"]({
          message: lang.handle(res.data.message),
        });
      } else {
        notification["success"]({
          message: lang.handle('Privilegios guardados correctamente'),
        });
        await fetchPrivileges(data.role);
      }

    } catch (err) {
      console.log("Error devuelto:", err);
      notification["error"]({
        message: lang.handle('Error en la operación'),
      });

    } finally {
      updateUI('isSubmitting', false);
    }
  };

  // ===== 5. EFFECTS =====
  useEffect(() => {
    if (data.role) {
      fetchPrivileges(data.role);
    }
  }, [data.role, fetchPrivileges]);

  // ===== 6. RENDER =====
  return (
    <form onSubmit={onSubmit}>
      <div className="userForm-selectMargin">
        <span className="form-select1">{lang.handle('Rol') + ":"}</span>
        <Select
          style={{ width: 200 }}
          placeholder={lang.handle('Selecciona un rol')}
          optionFilterProp="rol"
          onSelect={handleRoleChange}
          name="role"
          id="role"
          className="register-form__select"
          value={data.role}
        >
          {roles.map((option) => (
            <Option type='role_uuid' key={option.uuid} value={option.uuid}>
              {option.name}
            </Option>
          ))}
        </Select>
      </div>
      {data.role ? (
        <Spin spinning={ui.loading}>
        <div>
          <table className="table">
            <thead>
              <tr>
                <th scope="col">{lang.handle('Nombre')}</th>
                <th scope="col">{lang.handle('Privilegios')}</th>
              </tr>
            </thead>
            <tbody>
              {Object.keys(data.privileges).map((key) => {
                const group = data.privileges[key];
                return (
                  <tr key={key}>
                    <td>
                      <span className='title'>{lang.handle(group.label)}</span>
                      <br />
                      {lang.handle(group.description)}
                    </td>
                    <td className='row-priv'>
                      {Object.keys(group.privileges).map((privKey) => {
                        const privilege = group.privileges[privKey];
                        return (
                          <div key={privKey} className='celda'>
                            <Checkbox
                              id={privKey}
                              name={privKey}
                              checked={privilege.active}
                              onChange={handlePrivilegeToggle(key, privKey)}
                            /> {lang.handle(privilege.label)}
                          </div>
                        )
                      })}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          <div className="btn-save-privileges">
            <button
              id="button-save"
              className="btn btn-primary d-flex float-right"
              type="submit"
              disabled={ui.isSubmitting || ui.loading}
            >
              <div className="btnText">
                <p> {lang.handle('Guardar')}&nbsp;&nbsp; </p>
                <i className="material-icons"> {ui.isSubmitting ? 'sync' : 'save'} </i>
              </div>
            </button>
          </div>
        </div>
        </Spin>
      ) : (
        <div>{lang.handle('Debe seleccionar un rol')}</div>
      )}
    </form>
  );
}

export default withLocale(PrivilegesTable);
